<template>  
  <div id="emptyState">
    {{ text }}
  </div>
</template>

<script>  

  export default {  
    props: {
      text: {
        required: true,
        type: String
      }
    }
  };

</script>

<style lang="scss" scoped>  

  @import '../css/global.scss';

  #emptyState {
    
    @include fontPrimary500();

    padding: 16px 0;
    text-align: center;
    color: rgba(0,0,0,.24);
    font-size: 14px;
    letter-spacing: .5px;
    text-transform: uppercase;
    user-select: none;
  }

</style>  


// WEBPACK FOOTER //
// src/components/EmptyState.vue